module.exports = __webpack_public_path__ + "fonts/MarsCentra-Book.566bc1cb.otf";